import { render, staticRenderFns } from "./unload-cargo-info.vue?vue&type=template&id=8790fbd8"
import script from "./unload-cargo-info.vue?vue&type=script&lang=js"
export * from "./unload-cargo-info.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports